import { Member, MemberInfo } from "../../account/type/member";

export class MemberAdapter {
  static toOutputDTO(res: any): MemberInfo {
    return {
      account_num: res.accounts,
      limit: res.account_limit,
      support_num: res.supports,
      partner_num: res.partners,
      user_num: res.users,
      member: res?.data?.map((e: any) => ({
        login_user_id: e.user_id,
        client_id: e.vendor_id,
        email: e.email,
        name: e.name,
        role: e.status !== "" ? e.status : 0,
        stop_flg: e.stop_flg ? e.stop_flg : null,
        login_at: e.login_date !== "" ? e.login_date : null,
        pwd_flg: e.pwd_flg,
        updated_at: e.pwd_date !== "" ? e.pwd_date : null,
      })) || []
    };
  }
}
